import { commonChartTooltip } from '@shared/variables/echart-common.variable';
import EChartOption = echarts.EChartOption;
import UnitUtil from "@shared/utils/unit.util";

export const commonLineChartUtil = ({
                                      xAxisData,
                                      yAxisData,
                                      grid,
                                      tooltipFormatter,
                                      type,
                                      markLineData,
                                      opacity = 1
                                    }: {
  xAxisData: string[] | number[],
  yAxisData: string[] | number[],
  grid: EChartOption.Grid,
  markLineData?: number,
  tooltipFormatter,
  type: 'success' | 'fail' | 'GIT_EFFICIENCY_AND_IMPACT_SUMMARY_SCORE_CARD',
  opacity?: number
}): EChartOption => {
  return {
    grid,
    yAxis: {
      type: 'value',
      show: false,
      data: yAxisData
    },
    xAxis: {
      type: 'category',
      show: false,
      data: xAxisData
    },
    tooltip: {
      ...commonChartTooltip,
      trigger: 'axis',
      formatter: tooltipFormatter,
      extraCssText: 'margin-top: 50px'
    },
    series: [
      {
        smooth: true,
        showSymbol: false,
        data: yAxisData,
        type: 'line',
        areaStyle: {
          color: type === 'success' ? '#eef9ff' : '#fef3f6',
          opacity
        },
        itemStyle: {
          normal: {
            color: type === 'success' ? '#4fc4ff' : '#fc6888',
            opacity
          }
        },
        lineStyle: {
          width: 2,
          color: type === 'success' ? '#4fc4ff' : '#fc6888',
          opacity
        },
        markLine: {
          data: [{
            yAxis: markLineData ? markLineData : -1
          }]
        }
      }
    ]
  };
};

export const commonDoraLineChartUtil = ({
                                      xAxisData,
                                      yAxisData,
                                      grid,
                                      tooltipFormatter,
                                      type,
                                      dataZoom,
                                      markLineData,
                                      opacity = 1
                                    }: {
  xAxisData: string[] | number[],
  yAxisData: string[] | number[],
  grid: EChartOption.Grid,
  markLineData?: number,
  tooltipFormatter,
  dataZoom?: any[],
  type: 'success' | 'fail',
  opacity?: number }): EChartOption => {
  const yAxisLabelFormatter = {
    formatter: (x: number): any => {
      if(x > 10000) {
        const minutes = UnitUtil.minutes(x);
        const hours = UnitUtil.hours(x);
        let days = UnitUtil.days(x);
        const weeks = UnitUtil.weeks(x);
        const years = UnitUtil.years(x);

      if (years) {
        return `${years}y`
      }

      if (weeks) {
        days = days % 7;
        return days && days > 0 ? `${weeks}w ${days}d` : `${weeks}w`
      }

      if (days) {
        return hours ? `${days}d ${hours}h` : `${days}d`
      }

      if (hours) {
        return minutes ? `${hours}h ${minutes}m` : `${hours}h`
      }

      if (minutes) {
        return `${minutes}m`
      }
    }
      else {
        return x;
      }
    }
  };
  return {
    grid: {
      left: '3%',
      right: '4%',
      bottom: '13%',
      containLabel: true
    },
    yAxis: {
      type: 'value',
      boundaryGap: false,
      axisLabel:  yAxisLabelFormatter,
      splitLine: {
        lineStyle: {
          width: 0.5
        }
      }
    },
    xAxis: {
      type: 'category',
      data: xAxisData
    },

    tooltip: {
      ...commonChartTooltip,
      trigger: 'axis',
      formatter: tooltipFormatter,
      axisPointer: {
        type: 'shadow'
      }
    },
    dataZoom: [
      {
        type: 'inside'
      },
      {
        type: 'slider'
      }
    ],
    series: [
      {
        smooth: true,
        data: yAxisData,
        type: 'line',
        itemStyle: {
          normal: {
            color: '#4fc4ff',
          }
        },
        lineStyle: {
          width: 1,
          color: '#4fc4ff'
        },
        markLine: {
          data: [{
            yAxis: markLineData ? markLineData : -1
          }]
        }
      }
    ]
  };
};
